import { MENU_ROUTES, Roles } from 'enums';

export const getMenuRoutes = (incomingRole: Roles) => {
  if (!incomingRole) return [];

  return MENU_ROUTES.filter(menu => menu.visibleFor.some(role => role === incomingRole));
};
